import { render } from "./AverageCallDuration.vue?vue&type=template&id=df21fa76&ts=true"
import script from "./AverageCallDuration.vue?vue&type=script&lang=ts"
export * from "./AverageCallDuration.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__